import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface ChatContainerProps {
  children: ReactNode
  className?: string
}

export function ChatContainer({ children, className }: ChatContainerProps) {
  return (
    <div
      className={cn('p-4 space-y-2', className)}
      style={{ backgroundColor: '#efeae2', backgroundImage: 'radial-gradient(circle, rgba(0,0,0,0.03) 1px, transparent 1px)', backgroundSize: '12px 12px' }}
    >
      {children}
    </div>
  )
}

interface ChatBubbleProps {
  from: 'in' | 'out'
  time?: string
  tag?: ReactNode
  highlighted?: boolean
  children: ReactNode
}

export function ChatBubble({ from, time, tag, highlighted, children }: ChatBubbleProps) {
  return (
    <div className={cn('flex', from === 'out' && 'justify-end')}>
      <div
        className={cn(
          'max-w-[78%] p-3 rounded-lg shadow-sm text-sm text-slate-700',
          from === 'in' ? 'bg-white rounded-tl-sm' : 'rounded-tr-sm',
          from === 'out' && 'bg-[#dcf8c6]',
          highlighted && 'border-2 border-amber-300'
        )}
      >
        <div className="whitespace-pre-wrap leading-relaxed">{children}</div>
        {(time || tag) && (
          <div className="text-[10px] text-slate-500 text-right mt-1 flex items-center justify-end gap-1">
            {tag}
            {time}
          </div>
        )}
      </div>
    </div>
  )
}
